module.exports = __webpack_public_path__ + "img/61.da2fef76.png";